import { WixBlocksService } from '@wix/ambassador-wix-blocks-service/http';
import { EnhancedError } from '../utils/EnhancedError';
export class MetaSiteManager {
    constructor() {
        this.wixBlocksConsumption = WixBlocksService('/_api/wix-blocks-service/').WixBlocksConsumption();
    }
    async getSiteUrl(metaSiteId) {
        const response = await this.wixBlocksConsumption()
            .getPanelURL({
            metaSiteId,
        })
            .catch((error) => {
            throw new EnhancedError(`Cannot get site url`, {
                error,
                metaSiteId,
            });
        });
        return response.url;
    }
}
//# sourceMappingURL=MetaSiteManager.js.map